module.exports = __webpack_public_path__ + "img/rabbit.2e3b34f3.svg";